import { CheckoutWorksController } from '../types';
import { useBuyWorks } from './useBuyWorks';
import { CheckoutStepController } from './useCheckoutStep';
import { useDrawWorks } from './useDrawWorks';

type UseWorksArgs = {
  initialWorkIds: string[];
  isDraw: boolean;
  productShopifyId: string;
  roomVariantIds: string[] | null;
  step: CheckoutStepController;
};

export const useWorks = ({
  initialWorkIds,
  isDraw,
  productShopifyId,
  roomVariantIds,
  step,
}: UseWorksArgs): CheckoutWorksController => {
  const drawWorks = useDrawWorks({ step });
  const buyWorks = useBuyWorks({
    initialWorkIds,
    productShopifyId,
    roomVariantIds,
  });

  if (isDraw) {
    return drawWorks;
  }

  return buyWorks;
};
